export default class AccountsFrameworksIndex {

  constructor() {}

  render() {

    // Enable framework on select
    $('.enabled-framework-input').change(function() {
    	let hiddenInput = $(this).closest('.custom-control').find('.hidden-destroy');
      if ($(this).is(':checked')) {
        hiddenInput.val('false');
      } else {
        hiddenInput.val('true');
      }
    })

    // Scroll sections container on load
    let p = $('.form-container').data("scroll-p");
    if (typeof p !== "undefined") {
      $('.form-container').scrollTop(p);
    }

    // Add scroll p before submit
    $('#frameworksUpdate').submit(function() {
      let scrollFilter = $('.form-container').scrollTop();
      $('#frameworksUpdate').prepend('<input type="hidden" name="sp" value="' + scrollFilter + '">');
    });

  }

}

